<template>
  <div>
    <HeadBanner :itemData="$store.state.selected_menu" />
    <Breadcrumb />

    <div class="container">
      <div class="mTransfer-list">
        <MoneyTransferBox
          v-if="_.get(this.$store.state.current_content, 'secondary.MoneyTransfers.conf.enabled')==1"
          :itemData="_.get(this.$store.state.current_content,'secondary.MoneyTransfers.data')"
        />
      </div>
    </div>
    <ReasonsSlider class="no-bg"
      v-if="_.get(this.$store.state.current_content, 'secondary.ReasonsSlider.conf.enabled')==1"
      :itemData="_.get(this.$store.state.current_content,'secondary.ReasonsSlider')"
    />
    <ProductsSlider
      v-if="_.get(this.$store.state.current_content, 'secondary.ProductsSlider.conf.enabled')==1"
      :itemData="_.get(this.$store.state.current_content,'secondary.ProductsSlider')"
    />
    <MoreWaysForBanking />
    <CalculatorCurrency
      v-if="_.get(this.$store.state.current_content, 'secondary.CalculatorCurrency.conf.enabled')==1"
      :itemData="_.get(this.$store.state.current_content,'secondary.CalculatorCurrency.data')"
    />

    <!-- <CalculatorLoans calcType="ipotekuri"/> -->
  </div>
</template>

<script>
import HeadBanner from "@/components/HeadBanner";
import Breadcrumb from "@/components/Breadcrumb";
import MoneyTransferBox from "@/components/MoneyTransferBox";
import MoreWaysForBanking from "@/components/MoreWaysForBanking";
import ProductsSlider from "@/components/ProductsSlider";
import ReasonsSlider from "@/components/ReasonsSlider";
import CalculatorLoans from "@/components/CalculatorLoans";

export default {
  components: {
    HeadBanner,
    Breadcrumb,
    MoneyTransferBox,
    MoreWaysForBanking,
    ProductsSlider,
    ReasonsSlider,
    CalculatorLoans,
  },
  data() {
    return {
      transfers: false,
    };
  },

  watch: {
    // "$store.state.current_content.primary":{
    //       immediate: true,
    //       handler: function() {
    //           this.transfers = this.$store.state.current_content.primary;
    //       }
    //   },
  },
};
</script>

<style>
.no-bg.reasonsSliderContainer{
  margin-bottom: 90px;
}
.no-bg.reasonsSliderContainer:after{
  display: none;
}
@media(max-width: 767px){
  .no-bg.reasonsSliderContainer{
    margin-bottom: 55px;
  }
}
</style>